import React, { useEffect, useRef, useState } from 'react';
import profileImage from '../images/hiteshsatashiya.jpeg';

const About = () => {
    const [stats, setStats] = useState({ projects: 0, clients: 0, years: 0 });
    const [hasAnimated, setHasAnimated] = useState(false);
    const statsRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !hasAnimated) {
                    animateStats();
                    setHasAnimated(true);
                }
            },
            { threshold: 0.5 }
        );

        if (statsRef.current) {
            observer.observe(statsRef.current);
        }

        return () => observer.disconnect();
    }, [hasAnimated]);

    const animateStats = () => {
        const targets = { projects: 50, clients: 30, years: 5 };
        const duration = 2000;
        const steps = 60;
        const stepDuration = duration / steps;

        let currentStep = 0;

        const interval = setInterval(() => {
            currentStep++;
            const progress = currentStep / steps;

            setStats({
                projects: Math.floor(targets.projects * progress),
                clients: Math.floor(targets.clients * progress),
                years: Math.floor(targets.years * progress)
            });

            if (currentStep >= steps) {
                setStats(targets);
                clearInterval(interval);
            }
        }, stepDuration);
    };

    return (
        <section className="about" id="about">
            <div className="container">
                <div className="section-header" data-scroll-reveal>
                    <span className="section-number">01</span>
                    <h2 className="section-title">About Me</h2>
                </div>
                <div className="about-content">
                    <div className="about-image">
                        <div className="image-wrapper">
                            <img src={profileImage} alt="Profile" />
                            <div className="image-placeholder">
                            </div>
                        </div>
                    </div>
                    <div className="about-text" data-scroll-reveal="right">
                        <h3 className="about-subtitle">Passionate about creating meaningful digital experiences</h3>
                        <p className="about-description">
                            With over 5 years of experience in design and development, I've had the privilege
                            of working with startups and established brands to bring their visions to life.
                            My approach combines creative thinking with technical expertise to deliver solutions
                            that not only look great but perform exceptionally.
                        </p>
                        <p className="about-description">
                            I believe in the power of design to solve problems and create connections.
                            Every project is an opportunity to push boundaries and explore new possibilities.
                        </p>
                        <div className="about-stats" ref={statsRef}>
                            <div className="stat-item" data-scroll-reveal>
                                <span className="stat-number">{stats.projects}</span>
                                <span className="stat-label">Projects Completed</span>
                            </div>
                            <div className="stat-item" data-scroll-reveal>
                                <span className="stat-number">{stats.clients}</span>
                                <span className="stat-label">Happy Clients</span>
                            </div>
                            <div className="stat-item" data-scroll-reveal>
                                <span className="stat-number">{stats.years}</span>
                                <span className="stat-label">Years Experience</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
